export const useVipEventsStore = defineStore('vipEvents', () => {
  const vipEvents = ref<any[]>([]);
  const isStoreInitialized = ref(false);
  const VIP_EVENTS_ASYNC_KEY = 'vip_events';
  const currentVipEventId = ref<string | number | null>(null);

  /** The current vip event. */
  const currentVipEvent = computed(() => {
    return vipEvents.value.find(
      (event) => String(event.id) === String(currentVipEventId.value),
    );
  });

  /** Fetch the vip events. */
  const fetchVipEvents = async (locale: string, apiFetch: any) => {
    const response = await apiFetch(`/${locale}/api/events/`);
    vipEvents.value = response;
  };

  /** Ensure the store is initialized and fetch the vip events. */
  const ensureVipEvents = async (locale: string, apiFetch: any) => {
    if (isStoreInitialized.value) {
      return vipEvents.value;
    }
    await fetchVipEvents(locale, apiFetch);
    isStoreInitialized.value = true;

    // Set the current vip event id to the first event id.
    // TODO: Make this more robust.
    if (vipEvents.value.length > 0) {
      setCurrentVipEventId(vipEvents.value[0].id);
    }
    return vipEvents.value;
  };


  /** Set the selected vip event. */
  const setCurrentVipEventId = (eventId: string | number) => {
    currentVipEventId.value = eventId;
  };

  /** Reset the store. */
  const reset = () => {
    vipEvents.value = [];
    currentVipEventId.value = null;
    isStoreInitialized.value = false;
  };

  const reload = async (locale: string, apiFetch: any) => {
    reset();
    await ensureVipEvents(locale, apiFetch);
  };

  // currentVipEventId and isStoreInitialized must be returned so Pinia
  // hydrates them from SSR to the client (otherwise the list flashes away).
  return {
    vipEvents,
    currentVipEventId,
    isStoreInitialized,
    fetchVipEvents,
    ensureVipEvents,
    VIP_EVENTS_ASYNC_KEY,
    reset,
    setCurrentVipEventId,
    currentVipEvent,
    reload,
  };
});